import React, { useState, useEffect } from "react";
import {
  Eye,
  CandlestickChart,
  Pencil,
  CheckCircle,
  ArrowRight,
  Settings,
  Shield,
  Zap,
} from "lucide-react";
import Content from "../../../Components/Dashboard/Content/Content";
import { useNavigate } from "react-router-dom";

const BrokerConnectPage = () => {
  const navigate = useNavigate();

  const [selectedBroker, setSelectedBroker] = useState(null);
  const [connectionStep, setConnectionStep] = useState(1);
  const [userdetail, setUserdetail] = useState();

  const [apiCredentials, setApiCredentials] = useState({
    apiKey: "",
    apiSecret: "",
    passphrase: "",
  });
  const [isConnecting, setIsConnecting] = useState(false);
  const [connectionStatus, setConnectionStatus] = useState(null);
  const permission = JSON.parse(localStorage.getItem("permission"));

  const BrokerArray = [
    {
      name: "CoinDCX",
      id: 1,
      imgUrl: "https://coindcx.com/api/help/img/CoinDCX-Logo.png",
      description:
        "India's largest cryptocurrency exchange with advanced trading features",
      features: [
        "Spot Trading",
        "Futures Trading",
        "Advanced Charts",
        "API Access",
      ],
      status: "active",
      difficulty: "Easy",
      setupTime: "5 min",
    },
    {
      name: "Delta Exchange",
      id: 2,
      imgUrl:
        "https://play-lh.googleusercontent.com/RUooPad2OIFej3q8E3lUdIMfC9A_NUiXFn1Zr41BGHfgIYYDjOeJyPJ-ollns8-H_g",
      description:
        "Advanced derivatives trading platform with institutional-grade tools",
      features: [
        "Derivatives",
        "Options Trading",
        "Perpetual Futures",
        "Risk Management",
      ],
      status: "active",
      difficulty: "Medium",
      setupTime: "10 min",
    },
    {
      name: "Binance",
      id: 3,
      imgUrl:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR2CNwEe1W7zlY_r1ASpQkwS8pk-12hq20jaeN5V40&usqp=CAE&s",
      description:
        "World’s leading cryptocurrency exchange offering spot, futures, options, and a wide range of digital assets with deep liquidity",
      features: [
        "Spot & Futures Trading",
        "Options & Derivatives",
        "High Liquidity",
        "Advanced Security",
        "Staking & Earning Programs",
        "API & Mobile App Support",
      ],
      status: "active",
      difficulty: "Medium",
      setupTime: "10 min",
    },
    {
      name: "zebpay",
      id: 4,
      imgUrl: "https://press-release-v1.s3.ap-south-1.amazonaws.com/order/14935/1729513490712_content_img.jpeg",
      description:
        "India's first cryptocurrency exchange with a focus on security and compliance",
      features: ["Spot Trading", "Staking", "Recurring Buys", "API Access"],
      status: "inactive",
      difficulty: "Easy",
      setupTime: "5 min",
    },
    {
      name: "CoinSwitch",
      id: 5,
      imgUrl: "https://play-lh.googleusercontent.com/L0JfyWa6L3i_aYfeBtYI6oa-9wnuBznfIvWgp2asAL-O7VJDk4Kjqm8ShIa_c07LM8jqh_-R3-icMr-cvcUO",
      description:
        "A leading cryptocurrency exchange aggregator offering a wide range of coins and tokens with competitive rates",
      features: ["Multi-Exchange Access", "Wide Coin Selection", "Competitive Rates", "User-Friendly Interface"],
      status: "inactive",
      difficulty: "Easy",
      setupTime: "5 min",
    },
    {
      name: "Pi42",
      id: 6,
      imgUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAACoCAMAAABt9SM9AAAA1VBMVEUVFRVLefFMe/UTEAAQCQDX4fVNffkqPnU9YL4/Y8QnOGcOAAAAAABOfvtMevQRCwAUEw8PBQAUEw0PAADh6/8dJkDd5vVEdfFDa9M0UJtIdOYUEggODQw+cfE5Wa4vR4mkrLtTV16Um6nS3fWJpPIkM147XLQ2VKQyTZQZHSshLlIaIDIuRYUWFxkfKkoqPnQeHyA7PUIrLC95fonDzN62v9AzNTiguP3D0fSBnvKxw/Rmi/KAhpKht/NjaHBFbtu+x9np8v9XgfF9gYexxf9faIBzmP5TZKOQAAAF70lEQVR4nO2d6XKbSBRGzeIWqIGmkVAQyJKTjDbbsrNOtskoy8y8/yNNg2RFCwKua2q08J3yLyeq6py6ffvjosDFBQAAAAAAAAAAAAAA/yU959ArOBV6jvP8unfoVZwCmanL9vdXsFWG47x+cdm+vLxsv4GsQlRRvX3XTlUpWa8hq4Ce8/p6aQqyiuk5z9+vTEFWEUrVt3VVStbvkJWP8+r9pqrO5Yepf+hVHSfO2y1VHz9dXRmHXtVx4rxYd9XpfP5y9Uxj8tDLOkqcP9rr++/rjytPU/BDr+sYcf5sr6n68OxZakrz5qisXZznK1edl79dLVRpmm5D1g69N3mqlKy+OPTSjo6e8y5PlaaxCU7DbZxvy161qUrJakLWFk6WRX+19V+4yKRbONeZq6/etiokhx2yMNr5/ONqVxUOwy1SV52PX3JUqZbVxWG4jgrunZefFml9B3eYHHp9x0Tq6utOX19Vlnno9R0TztvvH/OaFVrWLs7P9qe9qlRhDZCyVjg//9q7A7OWhZS1wvn7n4Ky0jQvah16iUeDbLj5ZyB24Q7KVaEqJcvALlzAB2Wu9BGCwwLeLXOlufdIpCk+H5W68iJcRKcE0mZlrjQXo6wU42Je7sqbo7AUItT0UlfqGhqFpSJDkxXHqwwdHStt7eXHYFZYt8Ghl3pwEmFXcsXGyFgijCu0K0WM2QxvVGlX6Sa8qXt3T6RVaQumm7DuhWWGcXm6ytDrHrECPikZyKwxq/dJKKZRxS1Y+4YV8AGrdgqmrhq1Tg3mbfWy0txJnZu7oTJ75bLS3HGNm3vAh1UPwbq78s2pXf0QVK669XUlxLh6Y09dDWrrymgNNMIO1DzWrGtvN3iD0qxUbo/Dmn6/KFVVPS6kMNuo5c0cX8i7mNLX0y044XW8o5qYQZfUq9KymofrsV3MDrb6/xPf4PcjRlSlsy5f34K8e1eDq0PDFHdzQlxf4Ea3G1eDfOw2zl1WYvKmxSqOQn/B4ge+PpEJuOWys5blGyYf9jVyUaneNpAbYozZnGlnLCsRPHkYPcGUUjURm9lK3qQ3YM9TVmAIaQ7HkUu6qlngufHA3FTl80kWzs5Mlp8YwpQ8bPQjxnRqn1LobvTAt5SI2XLudfqyVA1lSCm5nA4bXWvO3CeJUqa08W1rS4jPG/qyPk9elhhHtqWw7WiuuS57WkGlpphnNbnYvieRDnMe/8rJyzJdT1/gPU1SisdcbdSU5o4LozVZa3snL0s+oYdvitKZG3Vv+K6pi4Q3NyYUJy8rubG8pxx6j55YNG4aUuRMFhJ+s3VD4+RlpQl92LU1l9SslCblaT4a3Egpcr+pnfD7ncnz6cu6SOOnyafNySiKFx1+X/9Ku5v6c+bGkdV9CFuqSe2ZVRl8GO2m2bOQleJnAUuGw8ZkbNlRHOtuBst+FLoWz22rP7lrhiaXpjD23ov3BW/kXnefjawlgUqlyprknEtxMZ3ehorb6cxQv2lJ5UgY+y1lGHLa1fKvu89N1ga+7wcZftVpp2GaDdvdN/c6a1k0fMOUzZFXcLJC1iPCeLBKRhSQtUSMy9MaZC0xrfJgC1lLainLN5Jg/9nnZ9Ei7w5zHWX54d3wfirSmCWXg67VuKvF5SwLrXnP+6ijLKOZBXYvns/TOddo1FeMFuOuWGPZ5RCzc77wWE9Zy0TpeY9zrsdp1yqU65C1YCWrAMhaAlkEIIsAZBGALAKQRQCyCEAWAcgiAFkEIIsAZBGALAKQRQCyCEAWAcgiAFkEIIsAZBGALAKQRQCyCEAWAcgiAFkEIIsAZBGALAKQRQCyCEAWAcgiAFkEIIsAZBGALAKQRQCyCEAWAcgiAFkEIIsAZBGALAKQRQCyCEAWAcgiAFkEIIuAPy1/3Dsb5/zve9Gt8DrW8Mxe6SStsn+0p89yHvzg+1rZg92YfXavZ5CWy/QC3DjM3UxJGBd+TnetM3ylk7zvWvvpN+SeR9cF8qFf8MHx/Vm+IiUQ5n5EQY82Cj9Yy1dZAAAAAAAAAAAAAABQyr/Rn3yT/GNX6AAAAABJRU5ErkJggg==",
      description: "A new broker with advanced trading features and seamless API integration",
      features: ["Spot Trading", "Futures Trading", "API Access", "Risk Management"],
      status: "active",
      difficulty: "Medium",
      setupTime: "7 min",
    },

  ];



  const handleBrokerSelect = (broker) => {
    setSelectedBroker(broker);
    setConnectionStep(2);
  };

  const containerStyle = {
    // background: 'linear-gradient(135deg, #eff6ff 0%, #e0e7ff 100%)',
  };

  const maxWidthStyle = {
    maxWidth: "1280px",
    margin: "0 auto",
  };

  const headerStyle = {
    textAlign: "center",
    marginBottom: "32px",
  };

  const spinKeyframes = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;

  const pulseKeyframes = `
    @keyframes pulse {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.5; }
    }
  `;

  // Media queries for responsive design
  const responsiveStyles = `
    @media (max-width: 768px) {
      .progress-steps {
        flex-direction: column !important;
        gap: 40px !important;
      }
      
      .step-item {
        flex-direction: column !important;
        align-items: center !important;
        width: 100% !important;
      }
      
      .progress-line {
        display: none !important;
      }
      
      .step-info {
        position: static !important;
        transform: none !important;
        margin-top: 16px !important;
      }
      
      .step-circle {
        width: 48px !important;
        height: 48px !important;
        font-size: 16px !important;
      }
      
      .brokers-grid {
        grid-template-columns: 1fr !important;
        gap: 16px !important;
      }
      
      .broker-card {
        padding: 20px !important;
      }
      
      .broker-header {
        flex-direction: column !important;
        align-items: flex-start !important;
        gap: 12px !important;
      }
      
      .broker-info {
        width: 100% !important;
      }
      
      .broker-meta {
        flex-direction: column !important;
        align-items: flex-start !important;
        gap: 4px !important;
      }
      
      .features-grid {
        grid-template-columns: 1fr !important;
      }
      
      .button-group {
        flex-direction: column !important;
        gap: 12px !important;
      }
      
      .form-container {
        padding: 0 10px !important;
      }
      
      .main-content {
        padding: 24px 16px !important;
      }
      
      .main-title {
        font-size: 2rem !important;
      }
      
      .section-title {
        font-size: 1.25rem !important;
      }
    }
    
    @media (min-width: 769px) and (max-width: 1024px) {
      .progress-steps {
        max-width: 700px !important;
      }
      
      .step-circle {
        width: 52px !important;
        height: 52px !important;
      }
      
      .step-info {
        min-width: 100px !important;
      }
      
      .step-title {
        font-size: 13px !important;
      }
      
      .step-desc {
        font-size: 11px !important;
      }
    }
    
    @media (min-width: 1025px) {
      .step-info {
        min-width: 140px !important;
      }
      
      .step-desc {
        white-space: normal !important;
        max-width: 140px !important;
      }
    }
    
    ${spinKeyframes}
    ${pulseKeyframes}
  `;

  return (
    <Content
      Page_title="Connect Broker"
      route="/admin/apicreateinfo"
      button_title="Back"
      Page_title_showClient=""
    >
      <div style={containerStyle}>
        <style>{responsiveStyles}</style>
        <div style={maxWidthStyle}>
          {/* Header */}

          {/* Main Content */}
          <div className="main-content1">
            {/* Step 1: Broker Selection */}
            {connectionStep === 1 && (
              <div>
                <h5 className="section-title1">Choose Your Broker</h5>
                <div className="brokers-grid1">
                  {BrokerArray?.map((broker) => (
                    permission?.broker_id?.some((data) => data.id == broker.id) && (
                      <div key={broker.id} className="broker-card1">
                        <div className="broker-header1">
                          <div className="broker-info1">
                            <img
                              src={broker.imgUrl}
                              alt={broker.name}
                              className="broker-image1"
                            />
                            <div>
                              <h5 className="broker-name1">{broker.name}</h5>
                              <div className="broker-meta1">
                                <span className="broker-meta-item1">
                                  <Settings className="broker-meta-icon1" />
                                  {broker.difficulty}
                                </span>
                                <span className="broker-meta-item1">
                                  <Zap className="broker-meta-icon1" />
                                  {broker.setupTime}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className={`status-badge1 status-${broker.status}1`}>
                            {broker.status === "active" ? "Available" : "Inactive"}
                          </div>
                        </div>

                        <p className="broker-desc1">{broker.description}</p>

                        <div className="features-grid1">
                          {broker.features.map((feature, index) => (
                            <div key={index} className="feature-item1 pb-2">
                              <CheckCircle className="feature-icon1" />
                              {feature}
                            </div>
                          ))}
                        </div>

                        <button
                          className="connect-button1 btn btn-primary mt-2 btn-sm"
                          onClick={() => {
                            const routes = {
                              CoinDCX: "/admin/apicreateinfo/coinDCXGuide",
                              "Delta Exchange": "/admin/apicreateinfo/Deltaexchange",
                              Binance: "/admin/apicreateinfo/binance",
                              zebpay: "",
                              CoinSwitch: "/admin/apicreateinfo/CoinSwitchGuide",
                              Pi42: "/admin/apicreateinfo/Pi42"

                            };

                            if (routes[broker.name]) {
                              navigate(routes[broker.name]);
                            }
                          }}
                        >
                          <span>View Process {broker.name}</span>
                          <ArrowRight className="arrow-icon1" />
                        </button>
                      </div>
                    )
                  ))}

                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Content>
  );
};

export default BrokerConnectPage;
